import { useNavigate, useParams } from "react-router";
import MeaningfulWork from "./MeaningfulWork";
import { useSearchParams } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import Spirituality from "./Spirituality";
import Relationships from "./Relationships";
import HobbiesAndInterests from "./HobbiesAndInterests";
import PhysicalHealth from "./PhysicalHealth";
import { useEffect } from "react";

export default function DomainDeepDive() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const domain = searchParams.get("domain");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if(!domain) {
    navigate("/")
  }

  function renderDomain() {
    switch (domain) {
      case "meaningful-work": return <MeaningfulWork />;
      case "clinical-spirituality": return <Spirituality />;
      case "relationships": return <Relationships />;
      case "hobbies-and-interests": return <HobbiesAndInterests />;
      case "physical-health": return <PhysicalHealth />;
    }
  }

  return (
    <div className="p-4 sm:p-8">
      <div onClick={() => navigate(-1)} className="flex items-center gap-1 mt-3 sm:mt-0 mb-5 text-blue-600 cursor-pointer hover:text-blue-800">
        <ArrowLeftIcon className="size-5" />
        Back
      </div>
      {renderDomain()}
    </div>
  );
}
